import { useTranslation } from '@lyearn/i18n';
import { LANGUAGE_I18N_MAP_WITH_LANG_ENUM_REVERSE } from '@/components/LanguageMenu/consts';

export function useCurrentLanguage() {
  const { i18n: currentI18n } = useTranslation('', { useSuspense: false });
  return LANGUAGE_I18N_MAP_WITH_LANG_ENUM_REVERSE[currentI18n.language];
}
